'use strict'

showTaxonomyUIDialog = require '@grpn/taxonomy-ui/dist/index_showDialog'
{ setItem } = require './local_storage'

module.exports =
  showTaxonomyDialog: (showTaxonomyPreferences, GIGModal, onUserClickedTaxonomyTile) ->
    return unless showTaxonomyPreferences
    showTaxonomyUIDialog(onUserClickedTaxonomyTile.bind(this), -> GIGModal.close())
    GIGModal.open(id: 'taxonomy-preferences-modal')
    setItem('shownTaxonomyPreferences', 'true')

  onUserClickedTaxonomyTile: (id, positiveOrNegative) ->
    fetchParam =
      data:
        id: id
        value: positiveOrNegative
        _csrf: @domConfig.csrfToken if !!@domConfig.csrfToken

    @taxonomyPreference.fetch fetchParam
